import { electronApis } from '@/features/electron-api';
import { inElectron } from '@/utils/capabilities';

import type { UpdateActivityReport } from '@electron/shared';

export function reportUpdateActivity(report: UpdateActivityReport): void {
  if (!inElectron()) return;
  void electronApis.system.reportUpdateActivity(report);
}
